import ApiResponse from "../models/apiResponse";
import apiClient from "./client";
import PostProperties from "../models/postProperties";
import Util from "./util";

export default {
  async all(params: any): Promise<ApiResponse> {
    const url = "/api/v1/posts";

    return await apiClient.get(url, {
      headers: Util.authHeaders(),
      params: params,
    });
  },
  async create(properties: PostProperties): Promise<ApiResponse> {
    const url = "/api/v1/posts";

    return await apiClient.post(url, properties, {
      headers: Util.authHeaders(),
    });
  },
  async update(
    postId: number,
    properties: PostProperties,
  ): Promise<ApiResponse> {
    const url = "/api/v1/posts/" + postId;

    return await apiClient.put(url, properties, {
      headers: Util.authHeaders(),
    });
  },
  async delete(postId: number): Promise<ApiResponse> {
    const url = "/api/v1/posts/" + postId;

    return await apiClient.delete(url, {
      headers: Util.authHeaders(),
    });
  },
};
